export interface LayoutGroup {
  id: number;
  created: string;
  lastUpdated: string;
  tenantId: string;
  groupId: string;
  startDate: string | null;
  endDate: string | null;
  startTime: string | null;
  endTime: string | null;
  days: string | null;
  isStateSlideshow: boolean | null;
  stateSlideshowChangePeriod: number | null;
  layouts: Layout[];
}

export interface Layout {
  id: number;
  created: string;
  lastUpdated: string;
  tenantId: string;
  layoutId: string;
  layoutGroupId: number;
  groupOrderNum: number | null;
  activationEvent: string | null;
  activationButtons: string | null;
  activationOfflineDelay: number | null;
  slideshowDuration: number | null;
  components: unknown[];
}

export const DAYS_OF_WEEK = [
  'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'
] as const;

export const ACTIVATION_EVENTS = [
  'DEFAULT', 'BUTTON_EVENT', 'OFFLINE_MODE', 'LOW_POWER', 'NO_POWER', 'SHUTDOWN_EVENT',
] as const;

/** Valid values for `activationButtons`, only meaningful when
 *  `activationEvent` is `'BUTTON_EVENT'`. */
export const ACTIVATION_BUTTONS = ['A', 'B', 'C', 'D'] as const;

// Request DTOs — match the backend protocol DTO JSON field names

export interface LayoutGroupRequest {
  groupId: string;
  startDate: string | null;
  endDate: string | null;
  startTime: string | null;
  endTime: string | null;
  days: string[] | null;
  isTemplateSlideshow: boolean | null;
  templateSlideshowChangePeriod: number | null;
}

export interface LayoutRequest {
  templateId: string;
  groupId: string;
  groupOrderNum: number | null;
  activationEvent: string | null;
  activationButtons: string[] | null;
  activationOfflineDelay: number | null;
  slideshowDuration: number | null;
  components: unknown[];
}
